var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 101,
    viewBox: "0 0 137 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0324 63.257L108.812 47.4266L124.156 21.1872L100.624 4.08832L12.8438 19.9158L21.0324 63.257Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9521 61.6499L52.7769 94.691L119.913 49.5475L124.157 21.1872",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.144 27.3488C111.666 27.3488 113.71 25.2929 113.71 22.7569C113.71 20.2209 111.666 18.1651 109.144 18.1651C106.622 18.1651 104.577 20.2209 104.577 22.7569C104.577 25.2929 106.622 27.3488 109.144 27.3488Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 96,
    fill: "var(--background)",
    transform: "translate(0 2.08051)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/offers.a49aba433277c40b1c6d682f5ada08be.svg";
export { ForwardRef as ReactComponent };